'use strict';
import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import translate from '../_utils/tools/translate';
import { builderDispatch, ShelfUI } from '../_utils/ui';
import DeliveryOptionFilter from './delivery-option-filter';

const DeliveryOptionFilters = ({
  selected_options: selectedOptions,
  modal,
  options,
  facets: pFacets,
  ariaLabel
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const [left, setLeft] = useState(0);
  const [fixLeft, setFixLeft] = useState(false);
  const componentRef = useRef(null);
  const joinedSelectedOptions = selectedOptions.sort().join('')

  let width;
  if (options.length <= 1) return null;
  useEffect(() => {
    setLeftPosition();
    document.addEventListener('click', handleClick);
    width = componentRef.current && componentRef.current.offsetWidth + 1 || 'auto';
    return () => window.removeEventListener('click', handleClick);
  }, []);

  const setLeftPosition = () => {
    const viewWidth = window.innerWidth;
    const rect = componentRef.current.getBoundingClientRect();
    const computedLeft = rect.left - (width / 2)

    setLeft(computedLeft < 7 ? 7 : computedLeft);
    if (viewWidth < 1250) {
      setFixLeft(true)
    }
  }

  const deliveryTitle = () => {
    const selectOptionCount = selectedOptions.length;
    return selectOptionCount > 0
      ? `${translate('Delivery')} (${selectOptionCount})`
      : translate('Delivery');
  };

  const handleCollapsedClicked = () => {
    setLeftPosition();
    setCollapsed(prevState => !prevState);
  };

  const updateOptions = options => {
    builderDispatch.delayedDispatch({
      type: ShelfUI.DELIVERY_OPTION_SELECTED,
      options: options,
    });
    handleCollapsedClicked();
  };

  const checkOptions = options => {
    return selectedOptions.includes(options);
  };

  const handleOptionSelected = options => {
    if (checkOptions(options)) {
      selectedOptions = []
    } else {
      if ((typeof options) === 'undefined') {
        selectedOptions = []
      } else {
        selectedOptions = [options]
      }
    }
    updateOptions(selectedOptions);
  };

  const handleClick = e => {
    if (componentRef.current && !componentRef.current.contains(e.target)) {
      setCollapsed(true);
    }
  };

  const facets = (pFacets || []).map(facet => parseInt(facet.key));

  return (
    <li className={classNames('m-1', { 'mt-4 modal-li': modal })} ref={componentRef} style={{ width: width }}>
      <div className='options-wrapper d-flex flex-column'>
        <button
          className={classNames('btn shelf-filter-dropdown-toggle', {
            'selected-button': selectedOptions.length > 0,
            'modal-button d-flex d-flex-row justify-content-between': modal,
          })}
          onClick={handleCollapsedClicked}
          aria-label={ariaLabel}
          aria-expanded={!collapsed}
          role="button"
        >
          {deliveryTitle()}
          <i
            className={classNames(
              'fa ml-2',
              collapsed ? 'fa-angle-down' : 'fa-angle-up',
              { 'pull-left': modal }
            )}></i>
        </button>

        <div
          role="menu"
          aria-hidden={collapsed}
          className={classNames('shelf-filter-dropdown px-4', {
            'd-none': collapsed,
            'py-3': !modal
          })}
          style={fixLeft && !isNaN(left) ? { left: left } : {}}>
          <ul className="list-unstyled" role="list">
            <DeliveryOptionFilter
              key={0}
              title="Show all"
              OptionKey={[]}
              available={true}
              selected={!joinedSelectedOptions}
              onToggle={handleOptionSelected}
              newUi={true}
            />
            {(options || []).map((option, i) => {
              const available = facets.length
                ? facets.some(facet => option.key !== facet)
                : option.available;
              return (
                <DeliveryOptionFilter
                  {...option}
                  key={i}
                  optionKey={option.key}
                  available={available}
                  selected={checkOptions(option.key)}
                  onToggle={handleOptionSelected}
                  newUi={true}
                />
              );
            })}
          </ul>
        </div>
      </div>
    </li>
  );
};

DeliveryOptionFilters.propTypes = {
  onClearAllFiltersClick: PropTypes.func,
  options: PropTypes.array,
  facets: PropTypes.array,
  selected_otpions: PropTypes.array,
  onClickedCollapsed: PropTypes.func,
  collapsed: PropTypes.bool,
  modal: PropTypes.bool,
};

export default DeliveryOptionFilters;
